import { Base } from './base'
import { Metadata } from '@/models/metadata'
import { Device } from '@/models/device'
import { PlcDevice } from '@/models/plc-device'
import { PlcData } from '@/models/plc-data'
import { ModbusDevice } from '@/models/modbus-device'
import { ModbusData } from '@/models/modbus-data'
import { AnalogDevice } from '@/models/analog-device'
import { Dlt645Device } from '@/models/dlt645-device'
import { Dlt645Data } from '@/models/dlt645-data'
import { DB } from '@/extensions/db'

export class MetadataManager extends Base {
  constructor (vueComponent) {
    super(vueComponent)

    this._metadata = new Metadata()
    this._device = new Device()
    this._plcDevice = new PlcDevice()
    this._plcData = new PlcData()
    this._modbusDevice = new ModbusDevice()
    this._modbusData = new ModbusData()
    this._analogDevice = new AnalogDevice()
    this._dlt645Device = new Dlt645Device()
    this._dlt645Data = new Dlt645Data()

    this._operationMap = {
      'point': {
        click: this._inspectPoint,
        edit: this._editPoint
      }
    }
  }

  async genTreeData () {
    const devices = await this._metadata.all()

    return Promise.all(devices.map(async device => {
      return {
        name: device.name,
        children: await Promise.all(device.points.map(async (point, index) => {
          return Object.assign({
            operations: [ 'click', 'edit' ],
            class: 'point',
            id: device.id,
            index
          }, point)
        }))
      }
    }))
  }

  async _inspectPoint (point) {
    const datas = await this._genFormDatas()

    this._requestForm('metadata', {
      deviceId: point.deviceId,
      dataId: point.dataId,
      devices: datas
    }, false)
  }

  async _editPoint (point) {
    const datas = await this._genFormDatas()

    const data = await this._requestForm('metadata', {
      deviceId: point.deviceId,
      dataId: point.dataId,
      devices: datas
    })

    await this._metadata.updatePoint(point.id, point.index, {
      deviceId: data.deviceId,
      dataId: data.dataId
    })
  }

  async _genFormDatas () {
    const plcDevices = await this._plcDevice.all()
    const modbusDevices = await this._modbusDevice.all()
    const analogDevices = await this._analogDevice.all()
    const dlt645Devices = await this._dlt645Device.all()

    /* plc device */
    const plcDatas = await Promise.all(plcDevices.map(async device => {
      return {
        name: device.name,
        id: device.deviceId,
        datas: (await this._plcData.plcId(device.id)).map((data, index) => {
          return {
            name: `${data.address}`,
            id: data.id
          }
        })
      }
    }))

    /* modbus device */
    const modbusDatas = await Promise.all(modbusDevices.map(async device => {
      const modbusDatas = await DB.modbusData.where({modbusDeviceId: device.id}).toArray()
      const pointsArray = await Promise.all(modbusDatas.map(async data => {
        const points = await DB.modbusDataPoint.where({modbusDataId: data.id}).toArray()
        return points.map(point => {
          point.parent = data
          return point
        })
      }))

      const datas = pointsArray.reduce((prev, item) => {
        return prev.concat(item)
      }, []).map(point => {
        return {
          name: `${point.parent.address}-${point.offset}-${point.regNum}`,
          id: point.id
        }
      })

      return {
        name: device.name,
        id: device.deviceId,
        datas
      }
    }))

    /* analog device */
    const analogDatas = await Promise.all(analogDevices.map(async device => {
      return {
        name: device.name,
        id: device.deviceId,
        datas: [
          {
            name: device.name,
            id: device.deviceId
          }
        ]
      }
    }))

    /* dlt645 device */
    const dlt645Datas = await Promise.all(dlt645Devices.map(async device => {
      return {
        name: device.name,
        id: device.deviceId,
        datas: (await this._dlt645Data.dlt645Id(device.id)).map((data, index) => {
          return {
            name: `${data.dataId}`,
            id: data.id
          }
        })
      }
    }))

    return Array.prototype.concat.apply([], [
      plcDatas,
      modbusDatas,
      analogDatas,
      dlt645Datas
    ])
  }
}



// WEBPACK FOOTER //
// ./src/components/home/controllers/metadata.js